import { render, staticRenderFns } from "./SelectCitationBV1.vue?vue&type=template&id=5119004e&scoped=true"
import script from "./SelectCitationBV1.vue?vue&type=script&lang=js"
export * from "./SelectCitationBV1.vue?vue&type=script&lang=js"
import style0 from "./SelectCitationBV1.vue?vue&type=style&index=0&id=5119004e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5119004e",
  null
  
)

export default component.exports